import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20936726"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sku"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "separator"
}, "-", -1));
const _hoisted_3 = {
  class: "asin"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_img = _resolveComponent("b-img");
  const _component_highlight_text_value = _resolveComponent("highlight-text-value");
  const _component_WrapWithCopy = _resolveComponent("WrapWithCopy");
  const _component_FlexRow = _resolveComponent("FlexRow");
  const _component_FlexColumn = _resolveComponent("FlexColumn");
  const _component_WrapWithSectionItem = _resolveComponent("WrapWithSectionItem");
  return _openBlock(), _createBlock(_component_WrapWithSectionItem, {
    selected: $props.selected,
    onSelect: _cache[0] || (_cache[0] = $event => _ctx.$emit('select', $props.item)),
    onSelectOnly: _cache[1] || (_cache[1] = $event => _ctx.$emit('selectOnly', $props.item)),
    onDeselect: _cache[2] || (_cache[2] = $event => _ctx.$emit('deselect', $props.item))
  }, {
    default: _withCtx(() => [_createVNode(_component_FlexRow, {
      gap: 8,
      styles: {
        alignItems: 'flex-start',
        justifyContent: 'flex-start'
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_b_img, {
        lazy: "",
        src: $props.image ?? '/assets/images/amazon-logo-transparent.svg',
        class: "custom-img",
        height: "32",
        width: "32"
      }, null, 8, ["src"]), _createVNode(_component_FlexColumn, {
        classes: "product",
        styles: {
          width: `${$props.width}px`
        },
        gap: 4
      }, {
        default: _withCtx(() => [_createVNode(_component_highlight_text_value, {
          class: "product-name",
          value: $props.product_name,
          query: $props.query,
          main: ""
        }, null, 8, ["value", "query"]), _createVNode(_component_FlexRow, {
          gap: 4,
          styles: {
            justifyContent: 'flex-start'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_WrapWithCopy, null, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_1, _toDisplayString($props.sku), 1)]),
            _: 1
          }), _hoisted_2, _createVNode(_component_WrapWithCopy, null, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString($props.asin), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["styles"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["selected"]);
}